//const API_URL = 'https://localhost:7285/api/Simulador';
 const API_URL = 'https://simulador-multibanco.azurewebsites.net/api/Simulador';

export async function simularMultibanco(dados) {
  const response = await fetch(`${API_URL}/simular-multibanco`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(dados),
  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.detail || 'Erro ao simular financiamento');
  }

  return response.json();
}